var exports = {
  "r9": "MenuItem.module__disabled___RUxDUG",
  "W$": "MenuItem.module__subtext___RUxDUG",
  "z": "MenuItem.module__sliderItem___RUxDUG",
  "Ry": "MenuItem.module__sliderHeader___RUxDUG",
  "KF": "MenuItem.module__sliderLabel___RUxDUG",
  "rv": "MenuItem.module__sliderValue___RUxDUG",
  "xJ": "MenuItem.module__sliderContainer___RUxDUG",
};

module.exports = exports;
